// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* cor quando passa o mouse por cima */\n.MuiButtonBase-root.buttonHover:hover {\n    background: rgb(36, 36, 36)\n  }\n  \n  /* cor enquanto não passa o mouse */\n  .MuiButtonBase-root.buttonHover {\n    background: rgb(71, 71, 71)\n  }", ""]);
// Exports
module.exports = exports;
